import Stack from '@careguide/stack'
import { Box, ContentBlock } from '@careguide/theme'
import { createGlobalStyle } from 'styled-components'
import styled from 'styled-components'
import css from '@styled-system/css'
import { Heading } from '@careguide/typography'
import Card from '@careguide/card'

import PageLayout from '../PageLayout'
import SettingsMenu from 'components/layout/SettingsPageLayout/SettingsMenu'
import { BusinessModelEnum } from 'graph/globalTypes'
import { Layout } from 'types/careguide-page'
import React from 'react'
import BackButtonMobile from 'components/Settings/BackButtonMobile'

const SettingsPageLayout: Layout<{ onMobileShow: 'menu' | 'content' }> = ({
  children,
  onMobileShow = 'content',
  backButton = {
    label: 'Settings',
    link: '/settings',
  },
  ...pageLayoutProps
}) => {
  const { viewer } = pageLayoutProps
  // @ts-ignore
  const { userType, emailDigest } = viewer.user
  const businessModel = viewer.site.businessModel
  const hideSubscriptionTab =
    userType === 'provider' && businessModel === BusinessModelEnum.ACTIVE_JOBS

  return (
    <PageLayout {...pageLayoutProps} hasFooter={false}>
      <GlobalStyle onMobileShow={onMobileShow} />
      <ContentBlock
        paddingX={{ _: '4', tablet: '5', desktop: '6' }}
        paddingY={{ _: '5', desktop: '6' }}
        maxWidth='1207px'
      >
        <Stack direction={{ _: 'vertical', desktop: 'horizontal' }} gap={{ _: '0', desktop: '7' }}>
          <MenuContainer display={onMobileShow === 'menu' ? 'block' : hideMobile}>
            <Heading as='h1' size='2'>
              Settings
            </Heading>
            <SettingsMenu hideSubscriptionTab={hideSubscriptionTab} emailDigest={emailDigest} />
          </MenuContainer>
          <ContentContainer display={onMobileShow === 'content' ? 'flex' : hideMobile}>
            <BackButtonMobile {...backButton} />
            <Stack gap='4'>{children}</Stack>
          </ContentContainer>
        </Stack>
      </ContentBlock>
    </PageLayout>
  )
}

const MenuContainer = styled(Box).attrs({
  width: { _: '100%', desktop: '244px' },
  minWidth: '244px',
  flexGrow: 0,
})`
  ${Heading} {
    ${css({
      display: ['block', undefined, 'none'],
      mb: [5, undefined, 0],
    })}
  }
`

const ContentContainer = styled(Box)`
  flex-grow: 1;
  flex-direction: column;
  ${BackButtonMobile} {
    ${css({ mb: '4' })}
  }
  ${Card} {
    ${css({ boxShadow: 'low-light' })}
  }
`

const hideMobile = { _: 'none', desktop: 'block' }

const GlobalStyle = createGlobalStyle<{ onMobileShow: string }>`
  ${({ onMobileShow }) =>
    css({
      body: {
        backgroundColor: [onMobileShow === 'menu' ? 'white' : '#f2f2f2', undefined, '#f2f2f2'],
      },
    })}
`

export default SettingsPageLayout
